import { render, staticRenderFns } from "./MinhaEmpresaFiliaisLista.vue?vue&type=template&id=37056d8a&"
import script from "./MinhaEmpresaFiliaisLista.vue?vue&type=script&lang=js&"
export * from "./MinhaEmpresaFiliaisLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VDataTable,VTooltip})
